<template>
  <v-dialog v-model="isShow" style="background: white" width="800" @close="close" @click:outside="close">
    <div style="background: white; padding: 16px">
      <div style="color: #4D4D4D; font-size: 16px; font-weight: bold; color: #4D4D4D">
        {{mode === 'create' ? 'Nhập' : 'Cập nhật'}} thông tin bộ mã chiến dịch
      </div>
      <div class="mt-3">
        <validation-observer ref="observer" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(handleSubmitForm)">
            <v-row class="px-3">
              <v-col cols="4" class="pa-0">
                <validation-provider v-slot="{ errors }" name="master_id" rules="required">
                  <v-text-field
                      dense
                      outlined
                      v-model="innerFormData.masterId"
                      maxlength="225"
                      :error-messages="errors"
                  >
                    <template v-slot:label>
                      Nhập Master_id <span style="color: red">(*)</span>
                    </template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="1" class="pa-0 d-flex align-center justify-center">
                <img src="../assets/line-betweeb.png" alt="" class="mb-6">
              </v-col>
              <v-col cols="3" class="pa-0">
                <validation-provider v-slot="{ errors }" name="content_id" rules="required">
                  <v-text-field
                      v-model="innerFormData.contentId"
                      :error-messages="errors"
                      dense
                      outlined
                      maxlength="225"
                  >
                    <template v-slot:label>
                      Nhập Content_id <span style="color: red">(*)</span>
                    </template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="1" class="pa-0 d-flex align-center justify-center">
                <img src="../assets/line-betweeb.png" alt="" class="mb-6">
              </v-col>
              <v-col cols="3" class="pa-0">
                <validation-provider v-slot="{ errors }" name="ad_id" rules="required">
                  <v-text-field
                      v-model="innerFormData.adId"
                      :error-messages="errors"
                      dense
                      outlined
                      maxlength="225"
                  >
                    <template v-slot:label>
                      Nhập Ad_id <span style="color: red">(*)</span>
                    </template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <div class="d-flex align-center justify-center mt-3">
              <v-btn color="#FF8057" type="submit">
                {{mode === 'create' ? 'Tạo' : 'Cập nhật'}}
              </v-btn>
              <v-btn color="#9A9A9A" @click="close">Hủy</v-btn>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "MasterContentPopup",
  props: {
    mode: {
      type: String,
      default: () => '',
    },
    isShow: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.$refs.observer.reset()
  },
  methods: {
    resetValidate() {
      this.$refs.observer.reset()
    },
    close() {
      this.$emit('close')
    },
    handleSubmitForm(invalid) {
      if (!invalid) {
        this.$emit('submit', this.innerFormData)
      }
    }
  },
  watch: {
    formData: {
      handler(val) {
        this.innerFormData = _.cloneDeep(val);
      },
      deep: true
    }
  },
  data() {
    return {
      innerFormData: {}
    }
  }
}
</script>

<style scoped>

</style>